import Notiflix, { Report } from 'notiflix'

// Configure Notiflix with higher z-index
Report.init({
    zindex: 1000000,
    backOverlay: true,
    backOverlayColor: 'rgba(0,0,0,0.5)',
    fontFamily: 'Arial, sans-serif',
    svgSize: '80px',
    plainText: true,
    titleFontSize: '18px',
    messageFontSize: '16px',
    buttonFontSize: '16px',
    cssAnimation: true,
    cssAnimationDuration: 300,
    cssAnimationStyle: 'fade',
})

export default Notiflix
